import { Tag, FavouriteObjectType } from "../../types/content";
import CardWithImageTopAndFooter from "./CardWithImageTopAndFooter";

export default function DirectoryEntryCard({
  objectId,
  objectType,
  image,
  bgColour = "",
  href,
  name,
  synopsis,
  primaryTags,
  user,
}: {
  objectId: string;
  objectType: FavouriteObjectType;
  image: string;
  bgColour?: string;
  href?: string;
  name: string;
  synopsis: string;
  primaryTags: Tag[];
  user: any;
}) {

  return (
    <CardWithImageTopAndFooter
      objectId={objectId}
      objectType={objectType}
      image={image}
      bgColour={bgColour}
      href={href}
      dataTitle={name}
      dataAuthor={name}
      dataTags={primaryTags.map((tag: any) => tag.name).join(", ")}
      middleContent={
        <>
          {/* Name */}
          <h1
            className="text-sm text-dark-blue font-bold line-clamp-1 overflow-hidden text-ellipsis break-words"
            title={name} // This sets the full text as the tooltip on hover
          >
            {name}
          </h1>

          {/* Tags */}
          <div className="flex flex-wrap gap-[0.1rem]">
            {primaryTags.map((tag: Tag, index: number) => {
              return (
                <span key={`tag-${index}`} className="flex items-center bg-transparent border border-dark-blue text-dark-blue px-3 py-0.2 rounded-full text-xxs font-bold">{tag.name}</span>
              );
            })}
          </div>

          {/* Synopsis */}
          <p title={synopsis} className="text-xs line-clamp-4 overflow-hidden text-ellipsis break-words text-dark-blue">{synopsis}</p>

        </>
      }
      footerContent={
        <>
          {/* Consumption */}
          <span className={`flex items-center text-white text-sm font-bold px-4 py-1 bg-yellow rounded-full`}>Event</span>

          {/* Rating */}
          {/* <div className={`group flex items-center gap-1`}>
            <StarIcon className={`shrink-0 h-5 w-5 text-${user !== null ? "yellow" : "secondary"}`} />
            {user !== null ? (
              <>
                <span className="text-sm font-bold">{rating}</span>
                <span className="text-sm font-bold">({reviews})</span>
              </>
            ) : (
              <span
                className="
              relative -bottom-10 mt-1 -translate-x-1/2
              px-2 py-1 bg-black text-white text-xs rounded
              opacity-0 group-hover:opacity-100 pointer-events-none z-50
            "
              >
                You must be logged in to see the ratings!
              </span>
            )}
          </div> */}

          {/* Price */}
          {/* {price && (
            <div className="flex items-center gap-1">
              <TagIcon className="h-5 w-5 text-dark-grey" />
              <span className="text-sm font-bold">{price}</span>
            </div>
          )} */}
        </>
      }
    />
  );
}
